module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-skills",
    attrs: {
      "id": "skills"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row skill-sets"
  }, [_c('div', {
    staticClass: "col span-1-of-2 steps-box"
  }, [_c('div', {
    staticClass: "works-step clearfix"
  }, [_c('transition', {
    attrs: {
      "name": "bounce",
      "enter-active-class": "bounceInLeft",
      "leave-active-class": "bounceOutRight"
    }
  }, [_c('div', [_vm._v("1")])]), _vm._v(" "), _c('b', [_vm._v("增强国际视野")]), _vm._v(" "), _c('p', [_vm._v("International Horizon Developing")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('v-waypoint', {
    on: {
      "waypoint-in": function($event) {
        _vm.$store.dispatch('updateSticky')
      },
      "waypoint-out": function($event) {
        _vm.$store.dispatch('updateSticky')
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Skills you will get")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works-step clearfix"
  }, [_c('div', [_vm._v("2")]), _vm._v(" "), _c('b', [_vm._v("扩大人脉网络")]), _vm._v(" "), _c('p', [_vm._v("Network Expanding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works-step clearfix"
  }, [_c('div', [_vm._v("3")]), _vm._v(" "), _c('b', [_vm._v("收获个人经验，提升职场竞争力")]), _vm._v(" "), _c('p', [_vm._v("Personal Experience & "), _c('br'), _vm._v(" Competitiveness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col span-1-of-2 steps-box"
  }, [_c('div', {
    staticClass: "works-step clearfix"
  }, [_c('div', [_vm._v("4")]), _vm._v(" "), _c('b', [_vm._v("提高综合素养，为申请海外高校做好准备")]), _vm._v(" "), _c('p', [_vm._v("Comprehensive Capabilities Promoting")])]), _vm._v(" "), _c('div', {
    staticClass: "works-step clearfix"
  }, [_c('div', [_vm._v("5")]), _vm._v(" "), _c('b', [_vm._v("个人品牌管理")]), _vm._v(" "), _c('p', [_vm._v("Manage Your Personal Brand")])]), _vm._v(" "), _c('div', {
    staticClass: "works-step clearfix"
  }, [_c('div', [_vm._v("6")]), _vm._v(" "), _c('b', [_vm._v("多任务处理能力, 决策能力, 创新能力")]), _vm._v(" "), _c('p', [_vm._v("Multitasking Handling Decision Making")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-81f90ef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Skills.vue
// module id = 107
// module chunks = 0